import React from 'react';
import { Stack, Inline, Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIntl } from '@atlassian/jira-intl';
import { Breadcrumb } from './breadcrumb';
import FeedbackButton from './feedback-button';
import messages from './messages';

// AKPageHeader has a margin in the bottom that will requires to tell the list view that needs to remove the top margin
// thus, as we dont have actions, or complex title I choose to just use primitives.
export const PageHeader = () => {
	const { formatMessage } = useIntl();
	return (
		<Stack
			xcss={[ff('jsw.list.sidebar-layout-update') ? pageHeaderStylesNew : pageHeaderStylesOld]}
		>
			<Breadcrumb />
			<Inline alignBlock={ff('jsw.list.sidebar-layout-update') ? 'start' : 'center'}>
				<Flex
					xcss={[
						titleWrapperStyles,
						ff('jsw.list.sidebar-layout-update') ? titleWrapperStylesNew : titleWrapperStylesOld,
					]}
				>
					{formatMessage(messages.listViewTitle)}
				</Flex>
				<Flex xcss={!ff('jsw.list.sidebar-layout-update') && actionsStyles}>
					<FeedbackButton />
				</Flex>
			</Inline>
		</Stack>
	);
};

const pageHeaderStylesNew = xcss({
	paddingTop: 'space.300',
});

const pageHeaderStylesOld = xcss({
	height: 'space.300',
	marginTop: 'space.300',
	marginLeft: 'space.300',
	zIndex: 'navigation',
});

const titleWrapperStyles = xcss({
	display: 'flex',
	maxWidth: '100%',
	overflow: 'hidden',
	flex: '1 1 auto',
});

const titleWrapperStylesNew = xcss({
	font: token('font.heading.large'),
});

const titleWrapperStylesOld = xcss({
	fontSize: '24px',
	fontWeight: 500,
	paddingTop: 'space.100',
	paddingBottom: 'space.100',
	paddingLeft: 'space.075',
	paddingRight: 'space.075',
});

const actionsStyles = xcss({
	paddingRight: 'space.300',
});
